import styled from 'styled-components';
import { Divider } from 'antd';
import { CountDownElementComponent } from './count-down.component';
import { SectionSummaryDetailComponent } from './section-summary-detail.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var paddingTopOfSectionSummary = 64;
export var marginBetweenItemsSectionSummary = 16;
var StyledSectionSummaryColumn = styled.div.withConfig({
  displayName: "section-summary-columncomponent__StyledSectionSummaryColumn",
  componentId: "sc-h9v7qy-0"
})(["display:flex;flex-direction:column;height:inherit;overflow:hidden;"]);
var StyledCountDownElementComponent = styled(CountDownElementComponent).withConfig({
  displayName: "section-summary-columncomponent__StyledCountDownElementComponent",
  componentId: "sc-h9v7qy-1"
})(["flex-shrink:0;"]);
var StyledDivider = styled(Divider).withConfig({
  displayName: "section-summary-columncomponent__StyledDivider",
  componentId: "sc-h9v7qy-2"
})(["margin:16px 0;flex-shrink:0;border-color:#e2e8f0 !important;"]);
var StyledSectionSummary = styled.div.withConfig({
  displayName: "section-summary-columncomponent__StyledSectionSummary",
  componentId: "sc-h9v7qy-3"
})(["flex:1;min-height:0;overflow-y:auto;"]);
export var SectionSummaryColumnComponent = function SectionSummaryColumnComponent(_ref) {
  var _ref$headerHeight = _ref.headerHeight,
      headerHeight = _ref$headerHeight === void 0 ? 75 : _ref$headerHeight,
      selectedSectionIndex = _ref.selectedSectionIndex,
      sectionSummaries = _ref.sectionSummaries,
      selectedSection = _ref.selectedSection,
      questions = _ref.questions,
      isLoadingQuestions = _ref.isLoadingQuestions,
      answeredQuestionIds = _ref.answeredQuestionIds,
      heightModal = _ref.heightModal,
      readonly = _ref.readonly,
      onCancelPin = _ref.onCancelPin,
      sectionLabels = _ref.sectionLabels,
      countDownLabels = _ref.countDownLabels,
      updateSelectedSection = _ref.updateSelectedSection,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(StyledSectionSummaryColumn, {
    $heightModal: heightModal,
    $headerHeight: headerHeight,
    children: [children ? children : /*#__PURE__*/_jsx(StyledCountDownElementComponent, {
      labels: countDownLabels
    }), /*#__PURE__*/_jsx(StyledDivider, {}), /*#__PURE__*/_jsx(StyledSectionSummary, {
      "data-testid": "section-summary-content",
      children: /*#__PURE__*/_jsx(SectionSummaryDetailComponent, {
        questions: questions,
        isLoadingQuestions: isLoadingQuestions,
        selectedSectionIndex: selectedSectionIndex,
        sectionSummaries: sectionSummaries,
        selectedSection: selectedSection,
        onCancelPin: onCancelPin,
        readonly: readonly,
        labels: sectionLabels,
        answeredQuestionIds: answeredQuestionIds,
        updateSelectedSection: updateSelectedSection
      })
    })]
  });
};